import React from 'react';
import { Row } from 'react-bootstrap';
import { FormFilterCard, FieldInput, FormCol4, FieldSelectIsΑpproved } from 'motion-components';
import { useTranslation } from 'react-i18next';
import { Company } from 'shared-pages/common/constants';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    console.log('filters', values);

    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [
          { name: likeObj },
          { addressLine1: likeObj },
          { phoneNumber1: likeObj },
          { companyVat: likeObj },
          { companyTaxOffice: likeObj },
        ],
      };
    }
    if (values.isApproved !== null) {
      let approvedFilter = values.isApproved === 'wait' ? null : values.isApproved;
      where = { ...where, isApproved: approvedFilter };
    }
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false, isGridInForm }) => {
  //

  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    isApproved: initialValues?.isApproved ?? '',
    groupId: initialValues?.groupId ?? undefined,
    regionId: initialValues?.regionId ?? undefined,
    addressNomos: initialValues?.addressNomos ?? undefined,
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol4}
          name="searchText"
          label={t('Αναζήτηση ( Όνομα, Διεύθυνση, Τηλέφωνο, ΑΦΜ, ΔΟΥ )')}
          type="search"
          disable={disable}
        />

        <FieldSelectIsΑpproved label={t('Εγκρίθηκε')} disable={disable} name="isApproved" />
      </Row>
    </FormFilterCard>
  );
};

